import { WitaConnector } from '@/services/repository/connector'
import { FormDataHandler } from '@/utils/helpers/FormDataHandler'
import { querySerializer } from '@/utils/helpers/URLs'

import {
  CreateChamadoTecnicoAnexoParams,
  CreateChamadoTecnicoAnexoResponse,
  DeleteChamadoTecnicoAnexoParams,
  DeleteChamadoTecnicoAnexoResponse,
  SearchChamadoTecnicoAnexosParams,
  SearchChamadoTecnicoAnexosResponse,
} from '../domain/chamado-tecnico-anexo'

const ROOT_URL = '/entity/call-tech-attachment'

export const ChamadoTecnicoAnexoService = {
  search: async (params: SearchChamadoTecnicoAnexosParams) => {
    const url = ROOT_URL + `?${querySerializer(params)}`
    return await WitaConnector.get<SearchChamadoTecnicoAnexosResponse>(url)
  },

  create: async (params: CreateChamadoTecnicoAnexoParams) => {
    const formData = FormDataHandler(params)
    const url = ROOT_URL
    return await WitaConnector.post<CreateChamadoTecnicoAnexoResponse>(
      url,
      formData,
    )
  },

  delete: async ({ id }: DeleteChamadoTecnicoAnexoParams) => {
    const url = ROOT_URL + `/${id}`
    return await WitaConnector.delete<DeleteChamadoTecnicoAnexoResponse>(url)
  },
}
